import React, { useCallback, useContext, useMemo, useState } from 'react'
import { Button } from 'components/buttons'
import { dialogTypes } from 'dialogs'
import { Row, Col, Label } from 'reactstrap'
import { Validator } from 'components/validation'
import { api as flavourCharacteristicsesApi } from 'store/modules/lookups/flavourCharacteristicses'
import { Select } from 'components/select'
import { AddItemButton } from 'components/buttons'
import { wsetType as wsetTypeEnum } from 'enums/wsetType'
import {
  colour as colourEnum,
  colourIntensity as colourIntensityEnum,
  aromaFlavourIntensity as aromaFlavourIntensityEnum,
  sweetness as sweetnessEnum,
  acidity as acidityEnum,
  tannins as tanninsEnum,
  alcohol as alcoholEnum,
  body as bodyEnum,
  finish as finishEnum,
  mousse as mousseEnum
} from 'enums/wsetTypes'

import { useStyles } from './item.css'
import { ValidationContext } from 'components/validation/validationContext'

export const WsetEvaluationItem = (props) => {

  const { entity, disabled, localize, index, onUpdate, canRemove, isInDialog, wsetEvaluations } = props

  const { wsetType, value, flavourCharacteristics } = entity
  const classes = useStyles()
  const [isRemoved, setIsRemoved] = useState(false)

  const { clearErrors } = useContext(ValidationContext)
  const wsetEvaluationName = useMemo(() => `wsetEvaluation[${index}]`, [index])

  const onTypeChange = useCallback(x => {
    if (x === wsetTypeEnum.aromaFlavourCharacteristics) {
      onUpdate({ wsetEvaluation: { wsetType: x, flavourCharacteristics: [] }, index })
    } else {
      onUpdate({ wsetEvaluation: { wsetType: x, value: 0 }, index })
    }
  }, [onUpdate, index])

  const onValueChange = useCallback(x => {
    if (wsetType === wsetTypeEnum.aromaFlavourCharacteristics) {
      onUpdate({ wsetEvaluation: { wsetType, flavourCharacteristics: x }, index })
    } else {
      onUpdate({ wsetEvaluation: { wsetType, value: x }, index })
    }
  }, [onUpdate, index, wsetType])

  const onFlavourCreated = useCallback(x => {
    onUpdate({ wsetEvaluation: { wsetType, flavourCharacteristics: [...flavourCharacteristics, x] }, index })
  }, [onUpdate, index, flavourCharacteristics, wsetType])

  const onRemove = useCallback(() => {
    setIsRemoved(true)
    onUpdate({ wsetEvaluation: null, index })
    setTimeout(() => clearErrors([wsetEvaluationName]), 10)
  }, [onUpdate, index, clearErrors, wsetEvaluationName])

  const sm = useMemo(() => isInDialog ? 4 : 3, [isInDialog])
  const selectedWsetTypeEnum = useMemo(() => {
    switch(wsetType) {
      case wsetTypeEnum.colourIntensity: return colourIntensityEnum
      case wsetTypeEnum.colour: return colourEnum
      case wsetTypeEnum.aromaFlavourIntensity: return aromaFlavourIntensityEnum
      case wsetTypeEnum.sweetness: return sweetnessEnum
      case wsetTypeEnum.acidity: return acidityEnum
      case wsetTypeEnum.tannins: return tanninsEnum
      case wsetTypeEnum.alcohol: return alcoholEnum
      case wsetTypeEnum.body: return bodyEnum
      case wsetTypeEnum.finish: return finishEnum
      case wsetTypeEnum.mousse: return mousseEnum
      default:
        return null
    }
  }, [wsetType])

  

  const showAromaFlavourCharacteristics = useMemo(() => wsetType === wsetTypeEnum.aromaFlavourCharacteristics, [wsetType])
  const isOptionDisabled = useCallback((option) => {
    
    if ((wsetEvaluations || []).length <= 1) { return false }
    return !!wsetEvaluations.find((x, idx) => idx !== index && x.wsetType === option)
  }, [index, wsetEvaluations])
  
  return (
    <Col sm={sm} className={classes.item}>
      <Row>
        <Col>
          <Label>{localize('wines.wsetType')}</Label>
          <Select
            value={wsetType}
            onChange={onTypeChange}
            placeholder={localize('wines.wsetType')}
            disabled={disabled}
            isOptionDisabled={isOptionDisabled}
            enum={wsetTypeEnum} />
        </Col>
      </Row>
      <Row>
        <Col>
          <Label>{localize('wines.evaluation')}</Label>
          {!showAromaFlavourCharacteristics &&
            <Select
              value={value}
              onChange={onValueChange}
              placeholder={localize('wines.evaluation')}
              disabled={disabled}
              enum={selectedWsetTypeEnum} />}
            {showAromaFlavourCharacteristics &&
              <AddItemButton dialogType={dialogTypes.flavourCharacteristicsDetail} disabled={disabled} onCreatedEntity={onFlavourCreated}>
                <Validator name={wsetEvaluationName} value={flavourCharacteristics} required disabled={disabled || isRemoved}>
                  <Select
                    isMulti
                    dataSource={flavourCharacteristicsesApi.get}
                    value={flavourCharacteristics}
                    onChange={onValueChange}
                    placeholder={localize('wines.evaluation')}
                    disabled={disabled} />
                </Validator>
              </AddItemButton>
              }
        </Col>
      </Row>
      {!disabled && canRemove && <Button
        className={classes.remove}
        color='secondary'
        title={localize('wines.removeEvaluationTooltip')}
        width={32}
        onClick={onRemove}
        icon='times'></Button>}
    </Col>
  )
}
